import React from "react";
import "./CSS/style.css";
import "./CSS/media.css";
import GitHubIcon from "@material-ui/icons/GitHub";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";

function Project({ title, description, technologies, gitlink, img, link }) {
  return (
    <div className="row project__showcase">
      <a
        href={link}
        target="_blank"
        className="col-md-7 project__img"
        style={{ backgroundImage: `url(${img})` }}
      >
        <div />
      </a>
      
      <div className="col-md-5 project__description">
        <div className="descrtiption__title">
          <h6>Featured Project</h6>
          <h2>{title}</h2>
        </div>
        <div
          className="description"
          style={{ marginLeft: "-120px", right: "0" }}
        >
          <p>{description}</p>
        </div>
        <p className="tech__description">{technologies}</p>
        <span className="description__icons">
          <a href={gitlink}>
            <GitHubIcon />
          </a>
          <a href={link}>
            <OpenInNewIcon />
          </a>
        </span>
      </div>
    </div>
  );
}

export default Project;
